module.exports = __webpack_public_path__ + "static/media/chef-avatar@2x.f1842773.png";